jQuery(document).ready(function( $ ){
	// START JQUERY

	// popover_enable - enable bootstrap popover (bootstrap)
	// tooltip_enable - enable tooltips (bootstrap)
	// aos_enable * - enable animate on scroll

	popover_enable = (typeof popover_enable !== 'undefined')? popover_enable : true;
	tooltip_enable = (typeof tooltip_enable !== 'undefined')? tooltip_enable : true;
	aos_enable = (typeof aos_enable !== 'undefined')? aos_enable : true;

	// Enable Bootstrap Popovers
	if(popover_enable) {
		$(function () {
			const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
	    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
		});
	}
	if(tooltip_enable) {
		$(function () {
			const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
			const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
		});
	}
	// AOS
	if(aos_enable) {
		AOS.init();
	}





	// END JQUERY
});
